var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['container', _vm._isMobile() ? 'mobile' : '']
  }, [_c('a-card', {
    attrs: {
      "bordered": false
    }
  }, [_c('a-form', {
    attrs: {
      "layout": "inline",
      "onSubmit": ""
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "活动界次"
    }
  }, [_c('j-dict-select-tag', {
    attrs: {
      "defaultShowAll": true,
      "type": "radioButton",
      "trigger-change": true,
      "dictCode": "event_orders",
      "placeholder": "请选择活动"
    },
    on: {
      "change": _vm.eventChange
    },
    model: {
      value: _vm.queryParam.eventId,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "eventId", $$v);
      },
      expression: "queryParam.eventId"
    }
  })], 1)], 1), _c('a-divider'), _vm.loading ? _c('a-skeleton') : _vm._e(), _c('a-list', {
    attrs: {
      "grid": {
        gutter: _vm._isMobile() ? 12 : 24,
        lg: 4,
        md: 3,
        sm: 2,
        xs: 1
      },
      "dataSource": _vm.dataSource,
      "pagination": _vm.pagination
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-card', {
          attrs: {
            "bordered": false
          },
          on: {
            "click": function click($event) {
              return _vm.toDetail(item);
            }
          }
        }, [_c('div', {
          staticClass: "img-zoom"
        }, [_c('img', {
          staticClass: "cover",
          attrs: {
            "src": item.cmsCover_url,
            "alt": ""
          }
        })]), _c('a', [_c('h3', {
          staticClass: "title"
        }, [_vm._v(_vm._s(item.cmsTitile))])])])], 1);
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };